import { render, staticRenderFns } from "./CreatePrescriptionDialog.vue?vue&type=template&id=0dd10f42&scoped=true"
import script from "./CreatePrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./CreatePrescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./CreatePrescriptionDialog.vue?vue&type=style&index=0&id=0dd10f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd10f42",
  null
  
)

export default component.exports